import React from "react";
import { Grid, Button, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import PrintIcon from "@mui/icons-material/Print";
import ReactToPrint from "react-to-print";

const Buttons = (props) => {
    const { t } = useTranslation();
    return (
        <Grid container alignItems="center" justifyContent="center">
            <Grid item>
                <Button id="cpm_b_2" style={{ margin: 10 }} disabled={props.isSaveDisable} variant="contained" color="primary" onClick={props.HandleEwoSave}>
                    {t("Save")}
                </Button>
            </Grid>
            <Grid item>
                <Button id="cpm_b_2" style={{ margin: 10 }} disabled={props.isCancelDisable} onClick={props.BackToBreakdownListPage} variant="contained" color="secondary">
                    {t("Cancel")}
                </Button>
            </Grid>
            <Grid item>
                <ReactToPrint
                    trigger={() => {
                        return (
                            <IconButton id="of_button_2" aria-label="download table" component="label">
                                <Button id="cpm_b_2" variant="contained" color="info">
                                    <PrintIcon fontSize="small" sx={{ marginLeft: 1 }} />
                                </Button>
                            </IconButton>
                        );
                    }}
                    content={() => props.componentRef}
                    pageStyle={props.pageStyle}
                />
            </Grid>
            <Grid item>
                <Button id="cpm_b_2" style={{ margin: 10 }} disabled={props.isOperatorDisable} variant="contained" color="info" onClick={props.HandleEwoSaveAsOperator}>
                    {t("SaveAsOperator")}
                </Button>
            </Grid>
        </Grid>
    );
};

export default Buttons;
